const ProductsActionTypes = {
	UPDATE_PRODUCTS: 'UPDATE_PRODUCTS',
	UPDATE_SELECTED_PRODUCT_KEYS: 'UPDATE_SELECTED_PRODUCT_KEYS',
	UPDATE_SELECTED_PRODUCT_ADDITIONAL_DATA: 'UPDATE_SELECTED_PRODUCT_ADDITIONAL_DATA',
	UPDATE_SELECTED_PRODUCT_CONSUMPTION_DATE: 'UPDATE_SELECTED_PRODUCT_CONSUMPTION_DATE',
	UPDATE_SELECTED_PRODUCT_AMOUNT: 'UPDATE_SELECTED_PRODUCT_AMOUNT',
}

export default ProductsActionTypes
